<template>
  <d-modal v-if="isActive" @close="isActive = false" :size="modalSize" :no-backdrop="true">
    <d-modal-header :class="classHeader">
      <d-modal-title>{{ title }}</d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <slot></slot>
    </d-modal-body>
    <d-modal-footer>
      <slot name="actions"></slot>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'modal',
  props: {
    title: {
      type: String,
      required: true,
    },
    modalSize: {
      type: String,
      default: 'lg',
    },
    typeModal: {
      type: String,
      required: true,
    },
    classHeader: {
      type: [String, Object],
      required: false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    isActive: {
      get() {
        return this.$store.state.toggle[this.typeModal];
      },
      set(value) {
        this.setToggle({ type: this.typeModal, bool: value });
      },
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    setClose() {
      this.setToggle({ type: this.typeModal, bool: !this.isActive });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  z-index: 1090;
  &--no-backdrop {
    background-color: rgba(0,0,0,0.5)!important;
    pointer-events: auto!important;
  }
}
</style>
